import { render, staticRenderFns } from "./ClassroomAssignmentCard.vue?vue&type=template&id=3b4d40dc&scoped=true&"
import script from "./ClassroomAssignmentCard.vue?vue&type=script&lang=js&"
export * from "./ClassroomAssignmentCard.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomAssignmentCard.vue?vue&type=style&index=0&id=3b4d40dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4d40dc",
  null
  
)

export default component.exports